////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.1                                                            //
//  Summary: "Nothing here yet" state — empty list responses, empty search   //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////

export interface EmptyStateProps {
  message: string;
}

export function EmptyState ({ message }: EmptyStateProps) {
  return <p className="p-4 text-center text-muted">{message}</p>;
}
